var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8773_640",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8773_640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 9.83334C2.66699 8.57778 3.03921 7.37223 3.78366 6.21667C4.5281 5.06111 5.55033 4.05 6.85033 3.18334C7.09477 3.01667 7.34755 3.00834 7.60866 3.15834C7.86977 3.30834 8.00033 3.53334 8.00033 3.83334V4.7C8.00033 5.07778 8.13088 5.39445 8.39199 5.65C8.6531 5.90556 8.97255 6.03334 9.35033 6.03334C9.53922 6.03334 9.71977 5.99167 9.89199 5.90834C10.0642 5.825 10.217 5.70556 10.3503 5.55C10.4392 5.43889 10.5531 5.36945 10.692 5.34167C10.8309 5.31389 10.9614 5.34445 11.0837 5.43334C11.7837 5.93334 12.3337 6.57223 12.7337 7.35C13.1337 8.12778 13.3337 8.95556 13.3337 9.83334C13.3337 10.8111 13.0948 11.7028 12.617 12.5083C12.1392 13.3139 11.5114 13.95 10.7337 14.4167C10.9225 14.15 11.0698 13.8583 11.1753 13.5417C11.2809 13.225 11.3337 12.8889 11.3337 12.5333C11.3337 12.0889 11.2503 11.6694 11.0837 11.275C10.917 10.8806 10.6781 10.5278 10.367 10.2167L8.00033 7.9L5.65033 10.2167C5.3281 10.5389 5.08366 10.8944 4.91699 11.2833C4.75033 11.6722 4.66699 12.0889 4.66699 12.5333C4.66699 12.8889 4.71977 13.225 4.82533 13.5417C4.93088 13.8583 5.0781 14.15 5.26699 14.4167C4.48921 13.95 3.86144 13.3139 3.38366 12.5083C2.90588 11.7028 2.66699 10.8111 2.66699 9.83334ZM8.00033 9.76667L9.41699 11.15C9.60588 11.3389 9.75033 11.55 9.85033 11.7833C9.95033 12.0167 10.0003 12.2667 10.0003 12.5333C10.0003 13.0778 9.80588 13.5417 9.41699 13.925C9.0281 14.3083 8.55588 14.5 8.00033 14.5C7.44477 14.5 6.97255 14.3083 6.58366 13.925C6.19477 13.5417 6.00033 13.0778 6.00033 12.5333C6.00033 12.2778 6.05033 12.0306 6.15033 11.7917C6.25033 11.5528 6.39477 11.3389 6.58366 11.15L8.00033 9.76667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.c474d93e359b9578cb2bc5ae6ca62458.svg";
export { ForwardRef as ReactComponent };